const recomendedTVShows = [
	{
		title: "Stranger Things - Season 1",
		description:
			"Attempting to Create Stranger Things as a Movie, since season 4 are film length.  When a young boy disappears, his mother, a police chief and his friends must confront terrifying supernatural forces in order to get him back.",
		tagline: null,
		year: "2016",
		release_date: "0000-00-00",
		imdb_id: "tt4574334",
		imdb_rating: "9",
		vote_count: "2",
		popularity: "1.96",
		youtube_trailer_key: "mnd7sFt5c3A",
		rated: "PG-13",
		runtime: 90,
		genres: ["Horror", "Sci-Fi"],
		stars: [
			"Millie Bobby Brown",
			"Finn Wolfhard",
			"Noah Schnapp",
			"Caleb McLaughlin",
			"Gaten Matarazzo",
			"Joe Keery",
			"David Harbour",
			"Natalia Dyer",
			"Winona Ryder",
			"Charlie Heaton",
			"Dacre Montgomery",
			"Matthew Modine",
		],
		directors: ["Matt Duffer", "Ross Duffer"],
		countries: null,
		language: null,
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "The Mandalorian",
		description:
			"After the fall of the Galactic Empire, lawlessness has spread throughout the galaxy. A lone gunfighter makes his way through the outer reaches, earning his keep as a bounty hunter.",
		release_date: "2019-11-12",
		imdb_id: "tt8111088",
		imdb_rating: "8.443",
		vote_count: "9800",
		popularity: "563.95",
		youtube_trailer_key: "aOC8E8z_ifw",
		rated: "TV-14",
		runtime: 42,
		year_started: 2019,
		genres: ["Fantasy", "Sci-Fi", "Action", "Adventure", "Drama", "Western", "Sci-Fi"],
		stars: [
			"Pedro Pascal",
			"Katee Sackhoff",
			"Carl Weathers",
			"Gina Carano",
			"Rio Hackford",
			"Werner Herzog",
			"Giancarlo Esposito",
			"Emily Swallow",
			"Omid Abtahi",
			"Nick Nolte",
		],
		creators: ["Jon Favreau"],
		countries: ["USA"],
		language: ["en"],
		production_companies: [
			"Lucasfilm Ltd.",
			"Golem Creations",
			"Fairview Entertainment",
			"Lucasfilm",
			"Walt Disney Studios",
		],
		networks: ["Disney+"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "The Crown",
		description:
			"The gripping, decades-spanning inside story of Her Majesty Queen Elizabeth II and the Prime Ministers who shaped Britain's post-war destiny. \n\nThe Crown tells the inside story of two of the most famous addresses in the world \u2013 Buckingham Palace and 10 Downing Street \u2013 and the intrigues, love lives and machinations behind the great events that shaped the second half of the 20th century. Two houses, two courts, one Crown.",
		release_date: "2016-11-04",
		imdb_id: "tt4786824",
		imdb_rating: "8.231",
		vote_count: "1969",
		popularity: "824.468",
		youtube_trailer_key: "JWtnJjn6ng0",
		rated: "TV-MA",
		runtime: 58,
		year_started: 2016,
		genres: ["Drama", "History", "Biography"],
		stars: [
			"Imelda Staunton",
			"Jonathan Pryce",
			"Lesley Manville",
			"Dominic West",
			"Claudia Harrison",
			"Marcia Warren",
			"Claire Foy",
			"Olivia Colman",
			"Matt Smith",
			"Tobias Menzies",
			"Emma Corrin",
			"Josh O'Connor",
		],
		creators: ["Peter Morgan", "Philip Martin", "Benjamin Caron", "Stephen Daldry"],
		countries: ["UK", "USA"],
		language: ["en", "English"],
		production_companies: ["Left Bank Pictures", "Sony Pictures Television Studios", "Sony Pictures Television"],
		networks: ["Netflix"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "The Office",
		description:
			"The everyday lives of office employees in the Scranton, Pennsylvania branch of the fictional Dunder Mifflin Paper Company.",
		release_date: "2005-03-24",
		imdb_id: "tt0386676",
		imdb_rating: "8.573",
		vote_count: "3940",
		popularity: "775.34",
		youtube_trailer_key: "tNcDHWpselE",
		rated: "TV-14",
		runtime: 24,
		year_started: 2005,
		genres: ["Comedy"],
		stars: [
			"Rainn Wilson",
			"John Krasinski",
			"Jenna Fischer",
			"Ed Helms",
			"B.J. Novak",
			"Steve Carell",
			"James Spader",
			"Ward Edmondson",
			"B. J. Novak",
			"Rashida Jones",
			"Angela Kinsey",
			"Brian Baumgartner",
		],
		creators: ["Ricky Gervais", "Stephen Merchant", "Greg Daniels", "Paul Feig", "Randall Einhorn", "Ken Kwapis"],
		countries: ["USA"],
		language: ["en", "English"],
		production_companies: [
			"Universal Television",
			"Deedle-Dee Productions",
			"Reveille Productions",
			"Shine America",
			"Universal Media Studios",
		],
		networks: ["NBC"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Black Mirror",
		description:
			"A contemporary British re-working of The Twilight Zone with stories that tap into the collective unease about our modern world.\u00a0\n\nOver the last ten years, technology has transformed almost every aspect of our lives before we've had time to stop and question it. In every home; on every desk; in every palm - a plasma screen; a monitor; a smartphone - a black mirror of our 21st Century existence.",
		release_date: "2011-12-04",
		imdb_id: "tt2085059",
		imdb_rating: "8.3",
		vote_count: "3028",
		popularity: "136.959",
		youtube_trailer_key: "V0XOApF5nLU",
		rated: "TV-MA",
		runtime: 60,
		year_started: 2011,
		genres: ["Fantasy", "Sci-Fi", "Drama", "Mystery", "Horror", "Thriller", "Sci-Fi"],
		stars: [
			"Daniel Lapaine",
			"Hannah John-Kamen",
			"Michaela Coel",
			"Douglas Hodge",
			"Brian Pettifer",
			"Jessie Cave",
			"Beatrice Robertson-Jones",
			"Daniel Kaluuya",
			"Toby Kebbell",
			"Rory Kinnear",
			"Hayley Atwell",
			"Lenora Crichlow",
		],
		creators: ["Charlie Brooker", "Owen Harris", "Carl Tibbetts", "Otto Bathurst"],
		countries: ["UK", "USA"],
		language: ["en", "English"],
		production_companies: ["House of Tomorrow", "Zeppotron"],
		networks: ["Channel 4", "Netflix"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "The Boys",
		description:
			"A group of vigilantes known informally as \u201cThe Boys\u201d set out to take down corrupt superheroes with no more than blue-collar grit and a willingness to fight dirty.",
		release_date: "2019-07-25",
		imdb_id: "tt1190634",
		imdb_rating: "8.471",
		vote_count: "9455",
		popularity: "467.6",
		youtube_trailer_key: "5SKP1_F7ReE",
		rated: "TV-MA",
		runtime: 60,
		year_started: 2019,
		genres: [
			"Fantasy",
			"Sci-Fi",
			"Action",
			"Adventure",
			"Superhero",
			"Comedy",
			"Crime",
			"Drama",
			"Sci-Fi & Fantasy",
			"Action & Adventure",
		],
		stars: [
			"Karl Urban",
			"Jack Quaid",
			"Antony Starr",
			"Erin Moriarty",
			"Dominique McElligott",
			"Jessie T. Usher",
			"Laz Alonso",
			"Chace Crawford",
			"Tomer Capone",
			"Karen Fukuhara",
			"Nathan Mitchell",
			"Jensen Ackles",
		],
		creators: ["Eric Kripke", "Evan Goldberg"],
		countries: ["USA"],
		language: ["en"],
		production_companies: [
			"Amazon Studios",
			"Original Film",
			"Sony Pictures Television Studios",
			"Kripke Enterprises",
			"Point Grey Pictures",
			"Kickstart Entertainment",
			"NightSky Productions",
			"Amazon MGM Studios",
			"Kickstart",
			"Sony Pictures Television",
		],
		networks: ["Prime Video", "Amazon"],
		status: "OK",
		status_message: "Query was successful",
	},
];

const getTvImageUrl = (id) => {
	return `/data/tvShowPosters/${id}.jpg`;
};

function filter(movies) {
	return movies.map((element) => {
		return {
			id: element.imdb_id,
			rating: element.imdb_rating ? parseFloat(element.imdb_rating).toFixed(1) : "N/A",
			title: element.title || "N/A",
			description: element.description || "No description available",
			img: getTvImageUrl(element.imdb_id),
			releaseYear: element.year_started || element.year || "N/A",
			actors: element.stars ? element.stars.slice(0, 3) : "N/A",
			genres: element.genres ? element.genres.map((genre) => genre) : [],
			trailer: "https://www.youtube.com/watch?v=" + element.youtube_trailer_key,
		};
	});
}

export default filter(recomendedTVShows);
